/** FinalizeResult → per-SKU CDT0–3 assignments CSV. */
import type { FinalizeResult } from "../domain/studioTypes";

const CSV_HEADER = [
  "sku_id",
  "upc",
  "name",
  "cdt0",
  "cdt1",
  "cdt1_priority",
  "cdt2",
  "cdt2_priority",
  "cdt3",
  "cdt3_priority",
];

/** Saved data is plain ASCII: transliterate typography and strip the rest, or consumers assuming ANSI see mojibake. */
const toAscii = (value: string): string =>
  value
    .replace(/[–—]/g, "-")
    .replace(/[‘’]/g, "'")
    .replace(/[“”]/g, '"')
    .replace(/[®™©]/g, "")
    .replace(/×/g, "x")
    .replace(/[^\x20-\x7E]/g, "");

const escapeCsv = (value: string | number): string => {
  const text = typeof value === "string" ? toAscii(value) : String(value);
  return /[",\n]/.test(text) ? `"${text.replace(/"/g, '""')}"` : text;
};

export const toCdtAssignmentsCsv = (result: FinalizeResult): string => {
  const rows = result.assignments.map((assignment) =>
    [
      assignment.skuId,
      assignment.upc,
      assignment.name,
      assignment.cdt0,
      assignment.cdt1,
      assignment.cdt1Priority,
      assignment.cdt2,
      assignment.cdt2Priority,
      assignment.cdt3,
      assignment.cdt3Priority,
    ]
      .map(escapeCsv)
      .join(","),
  );
  return [CSV_HEADER.join(","), ...rows].join("\n");
};
